import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ApiService from '../../service/ApiService';

class AlgoDisplayStockPrice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            symbolName: this.props.symbolName,
            ticker: this.props.ticker,
            interval: this.props.interval,
            show: false,
            price: 0,
            change: 0,
            changesPercentage: 0,
            volume: 0,
            prePrice: 0,
            preChange: 0,
            preChangesPercentage: 0,
            preVolume: 0,
        };
    }

    componentDidMount() {
        console.log('DisplayStockPrice', this.state.ticker);
        this.getData();
        this.setDynamicInterval();
    }

    getData() {
        ApiService.getQuotes(this.state.ticker)
            .then(result => {
                console.log('stockData', result)
                for (var i = 0; i < result.length; i++) {
                    this.setState({
                        price: result[i].price,
                        change: result[i].change,
                        changesPercentage: result[i].changesPercentage,
                        volume: result[i].volume
                    });
                }

                if (result !== undefined && result.length <= 0) {
                    this.setState({
                        price: 0,
                        change: 0,
                        changesPercentage: 0,
                        volume: 0
                    });
                }
                let { amPm, amPmStr } = this.getAmPm();

                if (amPm !== '') {
                    ApiService.getPrePostStockToday(this.state.ticker, '1min')
                        .then(result => {
                            console.log('PrePostStockPrice Data', result);
                            if (result !== undefined && result.results !== undefined & result.results.length > 0) {
                                let resData = result.results;
                                let close = resData[resData.length - 1].c;
                                let previousClose = this.state.price; //Last close
                                let percent = (close - previousClose) / previousClose * 100;
                                this.setState({
                                    prePrice: close,
                                    preChange: close - previousClose,
                                    preChangesPercentage: percent,
                                    preVolume: resData[resData.length - 1].v,
                                    show: true,
                                    amPm: amPm,
                                    amPmStr: amPmStr
                                });

                            } else {
                                this.setState({
                                    prePrice: 0,
                                    preChange: 0,
                                    preChangesPercentage: 0,
                                    preVolume: 0,
                                    show: false,
                                    amPm: amPm,
                                    amPmStr: amPmStr
                                });
                            }

                        })
                        .catch((error) => {
                            console.log(error);
                        });
                } else {
                    this.setState({
                        prePrice: 0,
                        preChange: 0,
                        preChangesPercentage: 0,
                        preVolume: 0,
                        show: false,
                        amPm: amPm,
                        amPmStr: amPmStr
                    });
                }

            })
            .catch((error) => {
                console.log(error);
            });
    }

    setDynamicInterval() {
        let intervalValue = 0;
        clearInterval(this.interval);
        if (this.state.interval === '1min') { intervalValue = 1 };
        if (this.state.interval === '5min') { intervalValue = 5 };
        if (this.state.interval === '15min') { intervalValue = 15 };
        if (this.state.interval === '30min') { intervalValue = 30 };
        if (this.state.interval === '1hour') { intervalValue = 60 };
        if (this.state.interval === '4hour') { intervalValue = 240 };
        if (this.state.interval === 'daily') { return };
        console.log('Calling dynamic interval', this.state.interval, intervalValue);
        this.getData();

        this.interval = setInterval(() => { this.setDynamicInterval() }, 1000 * 10 * intervalValue);
    }

    getAmPm() {
        let now = new Date();
        let hour = now.getHours();
        let minutes = now.getMinutes();
        let amPm = '';
        let amPmStr = '';
        console.log('now, hour, min', hour, minutes);

        if (hour >= 16) {
            amPm = 'ah';
            amPmStr = 'After Hours';
        } else if (hour <= 9) {
            if (hour === 9 && minutes >=30){
                amPm = '';
            } else{
                amPm = 'pm';
                amPmStr = 'Pre Market';
            }
        } else if ((hour >= 9 && minutes >= 30) && (hour <= 15 && minutes >= 59)) {
            amPm = '';
        }

        console.log('amPm', amPm, amPmStr);
        return { amPm, amPmStr }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        let noOfDecimals = parseFloat(this.state.price) < 1 ? 5 : 2;

        return (
            <Container>
                <Row style={{ marginLeft: '0', marginRight: '0' }}>
                    <Col xs={3} sm={3} md={3} lg={4} style={{ fontWeight: 'bold', paddingLeft: '0', paddingRight: '0' }}>{this.state.symbolName}</Col>
                    <Col xs={9} sm={9} md={9} lg={8} style={{ fontSize: '15px', fontWeight: 'bold', paddingLeft: '0', paddingRight: '0', color: parseFloat(this.state.change) >= 0 ? 'green' : 'red' }}>
                        {parseFloat(this.state.price).toFixed(noOfDecimals)}&nbsp;&nbsp;&nbsp;
                        {parseFloat(this.state.change).toFixed(2)}&nbsp;
                        ({parseFloat(this.state.changesPercentage).toFixed(2)}%)
                    </Col>
                </Row>
                {(this.state.show && this.state.amPm !== '') ? (
                    <Row style={{ marginLeft: '0', marginRight: '0' }}>
                        <Col xs={3} sm={3} md={3} lg={4} style={{ fontSize: '13px', color: 'grey', fontWeight: 'bold', paddingLeft: '0', paddingRight: '0' }}>
                            {this.state.amPmStr}:&nbsp;
                        </Col>
                        <Col xs={9} sm={9} md={9} lg={8} style={{ fontSize: '13px', fontWeight: 'bold', paddingLeft: '0', paddingRight: '0', color: parseFloat(this.state.preChange) >= 0 ? 'green' : 'red' }}>
                            {parseFloat(this.state.prePrice).toFixed(noOfDecimals)}&nbsp;&nbsp;&nbsp;
                            {parseFloat(this.state.preChange).toFixed(2)}&nbsp;
                            ({parseFloat(this.state.preChangesPercentage).toFixed(2)}%)
                        </Col>
                    </Row>
                ) : <></>}
            </Container>
        );

    }
}

export default AlgoDisplayStockPrice;
